import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");

var PaywallModal = require("components/users/teachers/PaywallModal");
var UIActions = require("lib/actions/UIActions");
var StudentListDisplay = require("components/org/student_lists/StudentListDisplay");

var Spinner = require("components/utility/Spinner");
var OrgTypes = require("lib/academic/OrgTypes");
var OrgDropdown = require("components/org/OrgDropdown");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("data/student_selector_section.scss");

function arrayToHash(ids) {
	var hash = {};
	if (ids) {
		_.each(ids, (x) => hash[x] = true);
	}
	return hash;
}
@connect(
	(state, props) => {

		return {
			studentLists: RosterSelectors.nonEmptyStudentLists({ state }),
			getStudents: (orgIdentifier) => {
				if (orgIdentifier) {
					return RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier: orgIdentifier })
				} else {
					return []
				}
				
			}
		}
	},
	(dispatch, props) => ({
		showHistoricalDataPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }))
	})
)

class StudentSelectorSection extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var selectedOrgIdentifier = null
		if (props.studentLists && props.studentLists.length > 0) {
			var studentListID = $wr.getURLParameterByName("student_list")
			if (studentListID) {
				var key = studentListID
			}	else {
				var key = props.studentLists[0].id
			}

			selectedOrgIdentifier = OrgTypes.toIdentifier({ 
				type: OrgTypes.STUDENT_LIST,
				key: key
			})
		}

		this.state = {
			selectedOrgIdentifier: selectedOrgIdentifier,
			studentsSelectedIDs: arrayToHash(props.initialStudentIDs)
		};
	}

	students() {
		var students = this.props.getStudents(this.state.selectedOrgIdentifier)
		return $wr.sortByName(students, "flexName");
	}

	onOrgSelect(identifier, studentListID) {
		if (this.props.showFullData) {
			var students = this.props.getStudents(identifier);
			var studentIDs = arrayToHash(_.pluck(students, "id"));
			this.setState({
				selectedOrgIdentifier: identifier,
				studentsSelectedIDs: studentIDs
			});
			this.props.changeSelection(studentIDs, studentListID);
		} else {
			this.props.showHistoricalDataPaywall();
		}
	}
	changeStudent(student) {
		if (this.props.showFullData) {
			var studentsSelectedIDs = _.clone(this.state.studentsSelectedIDs);
			if (this.allStudentsSelected()) {
				studentsSelectedIDs = { [student.id]: true };
			} else if (this.state.studentsSelectedIDs[student.id]) {
				delete studentsSelectedIDs[student.id];

				if (_.size(studentsSelectedIDs) == 0 && this.state.selectedOrgIdentifier) {
					// Instead of showing everyone, show the selected class
					studentsSelectedIDs = arrayToHash(
						_.pluck(this.students(), "id")
					);
				}

			} else {
				studentsSelectedIDs[student.id] = true;
			}
			this.setState({ studentsSelectedIDs: studentsSelectedIDs }, () => {
				this.props.changeSelection(this.state.studentsSelectedIDs);
			});
		} else {
			this.props.showHistoricalDataPaywall()
		}
	}
	changeAllStudents() {
		if (this.state.selectedOrgIdentifier === OrgTypes.ALL_STUDENTS_IDENTIFIER) {
			var studentsSelectedIDs = {}
		} else {
			var studentsSelectedIDs = _.clone(this.state.studentsSelectedIDs);
			_.each(this.students(), (student) => {
				studentsSelectedIDs[student.id] = true;
			});
		}

		this.setState({ studentsSelectedIDs: studentsSelectedIDs }, () => {
			this.props.changeSelection(this.state.studentsSelectedIDs);
		});
	}

	allStudentsSelected() {
		return (this.students().length == _.size(this.state.studentsSelectedIDs)) ||
			(_.size(this.state.studentsSelectedIDs) == 0);
	}

	componentDidMount() {
		if (!this.props.showFullData) {
			this.changeAllStudents()
		}
	}

	renderLoadingState() {
		return (
			<div>
				<Spinner placeholder={ true } scale={ 1.7 } />
			</div>
		)
	}

	render() {
		var allSelected = this.allStudentsSelected();
		var selectedStudents = _.map(this.students(), function(student) {
			if (this.state.studentsSelectedIDs[student.id] && !allSelected) {
				var className = " selectedRow";
			}
			if (!OrgTypes.isStudentListIdentifier(this.state.selectedOrgIdentifier)) {
				var studentListDisplay = <StudentListDisplay studentID={ student.id } />
			}
			return (
				<div key={ student.id } className={ "row studentRow " + className } onClick={ this.changeStudent.bind(this, student) }>
					<StudentAvatar disableAnimation student={ student } maxWidth={ 50 } />
					<div className="studentInfo">
						<span className="studentName">{ student.display_name }</span>
						{ studentListDisplay }
					</div>
				</div>
			);
		}.bind(this));

		if (allSelected) {
			var allStudentsClassName = " selectedRow";
		}

		if (this.props.loadingStudentLists) {
			var spinner = this.renderLoadingState();
		} else {
			var selector = (
				<OrgDropdown dropdownDisplay="link" 
					selectedIdentifier={ this.state.selectedOrgIdentifier }
					onSelect={ this.onOrgSelect }  />
			);
		}

		var studentsDisplay = (
			<div className="studentsDisplaySection">
				<div>
					<div className={ "row allStudentsRow " + allStudentsClassName }
						onClick={ this.changeAllStudents }>
						<img src={ require("owls/group-owls.png") } alt=""/>
						<span>Select All</span>
					</div>
					<div className="studentsInner">{ selectedStudents }</div>
				</div>
			</div>
		)
		
		return (
			<div className="studentSelectorSection hideOnPrint">
				{ spinner }
				{ selector }
				{ studentsDisplay }
			</div>
		);
	}
}

StudentSelectorSection.WrappedComponent.propTypes = StrictPropTypes({

	// Handler from @connect
	showHistoricalDataPaywall: PropTypes.func,
	showFullData: PropTypes.bool,
	getStudents: PropTypes.func,

	// From above
	changeSelection: PropTypes.func,
	initialStudentIDs: PropTypes.array,
	studentLists: PropTypes.array
});

module.exports = StudentSelectorSection;


// WEBPACK FOOTER //
// ./modules/components/data/StudentSelectorSection.js